// AUTO-GENERATED by script/stage-brand.mjs — DO NOT EDIT, DO NOT COMMIT.
// Staged for the "optio" brand. Regenerated on every predev/prebuild.
export const BRAND = "optio";
export const APP_NAME = "Optio";
export const WORDMARK = "optio";
export const TAGLINE = "The AI operator for the enterprise";
// Admin console footer label (the cloud control-plane is "Hub").
export const SERVER_LABEL = "Optio Server";
// Whether the public marketing/legal/download site surfaces ship. Off for
// on-prem Neos Hub builds — only the admin console + remote control remain.
export const SITE_ENABLED = true;
